import { useEffect, useState } from 'react';
import { MembershipSmsManagementTab, UpdateHistory } from './components';
import { Box, Tab, Tooltip, Tabs, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIContent } from '@/atomic/organisms';
import { SCUIBreadCrumb } from '@/atomic/molecules';
import { SCUIButton, SCUINoRecordComponent } from '@/atomic/atoms';
import { MasterDataQuery } from '../../services/query';
import { MSM } from './membershipSmsManagement.classes';

export const MembershipSmsManagement = () => {
    const [countryList, setCountryList] = useState<any>();
    const [activeTab, setActiveTab] = useState(0);
    const [hasFiltered, setHasFiltered] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState<any>(null);
    const [selectedPlatform, setSelectedPlatform] = useState<number>(1);

    const { t } = useTranslation();

    const handleTabChange = (_: any, newValue: number) => {
        setActiveTab(newValue);
    };

    const GetCountryList = async () => {
        MasterDataQuery.GetCountryList().then((res: any) => {
            if (res?.data) {
                setCountryList(res.data);
            }
        });
    };

    const tabs = [
        {
            label: t('membershipSmsManagement.membershipSmsManagementTab'),
            tooltip: t('membershipSmsManagement.membershipSmsManagementTab'),
            tabClassName: MSM.tabMembershipSms,
        },
        {
            label: t('membershipSmsManagement.updateHistory'),
            tooltip: t('membershipSmsManagement.updateHistory'),
            tabClassName: MSM.tabUpdateHistory,
        },
    ];

    const platforms = [
        { id: 1, name: 'Ecommerce' },
        { id: 2, name: 'Store' },
        { id: 3, name: 'LcwConnect' },
        { id: 4, name: 'CallCenter' },
    ];

    useEffect(() => {
        GetCountryList();
    }, []);

    return (
        <SCUIContent>
            <Box className={MSM.page} sx={{ padding: '16px', marginTop: '16px' }}>
                <div className={MSM.breadcrumbSection}>
                    <SCUIBreadCrumb
                        title={t('membershipSmsManagement.title')}
                        componentLink={'/sms-account-management'}
                        onClick={() => setHasFiltered(false)}
                    />
                </div>
                {!hasFiltered ? (
                    <Box
                        className={MSM.filterGate}
                        sx={{
                            padding: '16px',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <SCUINoRecordComponent />
                        <FormControl className={MSM.filterGateCountryField} style={{ width: '60%', marginTop: '16px' }}>
                            <InputLabel id="countrySelect">{t('membershipSmsManagement.selectCountry')}</InputLabel>
                            <Select
                                className={MSM.inputSelectCountry}
                                sx={{ marginBottom: '16px' }}
                                id="countrySelect"
                                label={t('membershipSmsManagement.selectCountry')}
                                value={selectedCountry?.countryId || ''}
                                onChange={(event) => {
                                    setSelectedCountry(
                                        countryList?.find((country: any) => country.countryId === event.target.value) ||
                                            ''
                                    );
                                }}
                                fullWidth
                            >
                                {(countryList || []).map((country: any) => (
                                    <MenuItem key={country.countryId} id={country.countryId} value={country.countryId}>
                                        <span style={{ fontSize: '14px' }}>
                                            {country.translatedCountryName} | {country.countryCode}
                                        </span>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={MSM.filterGatePlatformField} style={{ width: '60%', marginBottom: '16px' }}>
                            <InputLabel id="platformSelect">{t('membershipSmsManagement.selectPlatform')}</InputLabel>
                            <Select
                                className={MSM.inputSelectPlatform}
                                id="platformSelect"
                                label={t('membershipSmsManagement.selectPlatform')}
                                value={selectedPlatform}
                                onChange={(event) => {
                                    setSelectedPlatform(event.target.value as number);
                                }}
                                fullWidth
                            >
                                {platforms.map((platform) => (
                                    <MenuItem key={platform.id} value={platform.id}>
                                        {platform.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <SCUIButton
                            className={MSM.inputButtonFilter}
                            text={t('general.filter')}
                            type="primary"
                            sizeType="fixed"
                            size={'m'}
                            onClick={() => setHasFiltered(true)}
                        />
                    </Box>
                ) : (
                    <Box className={MSM.filteredShell}>
                        <Box className={MSM.tabsWrap}>
                            <Tabs
                                className={MSM.tabsRoot}
                                value={activeTab}
                                onChange={handleTabChange}
                                sx={{
                                    '& .MuiTab-root': {
                                        padding: '8px',
                                        minHeight: '40px',
                                        '&:hover': {
                                            backgroundColor: 'rgba(3, 169, 244, 0.7)',
                                            color: '#ffffff !important',
                                        },
                                    },
                                }}
                            >
                                {tabs.map((tab) => (
                                    <Tab
                                        key={tab.label}
                                        className={tab.tabClassName}
                                        label={
                                            <Tooltip title={tab.tooltip} arrow>
                                                <span>{tab.label}</span>
                                            </Tooltip>
                                        }
                                    />
                                ))}
                            </Tabs>
                        </Box>
                        <Box className={MSM.tabPanelWrap} sx={{ mt: 2, p: 1, width: '100%', display: 'flex' }}>
                            {activeTab === 0 && (
                                <MembershipSmsManagementTab
                                    selectedCountry={selectedCountry}
                                    selectedPlatform={selectedPlatform}
                                    platformList={platforms}
                                />
                            )}
                            {activeTab === 1 && (
                                <UpdateHistory selectedCountry={selectedCountry} selectedPlatform={selectedPlatform} />
                            )}
                        </Box>
                    </Box>
                )}
            </Box>
        </SCUIContent>
    );
};
